window.addEventListener('DOMContentLoaded', () => {
    const locationHash = window.location.hash;
    const $tabsHeader = $('.js-about-tabs-header');
    const $coffeeContainer = $('.js-about-page-coffee');

    // Переключение табов при загрузке страницы в зависимости от url
    if ($tabsHeader.length) {
        if (locationHash === '#contacts') {
            $tabsHeader.eq(2).tab('show').click();
        } else if (locationHash === '#cooperation') {
            $tabsHeader.eq(1).tab('show').click();
        }
    }

    // Блок с кофе должен отображаться только при активном первом табе
    if ($coffeeContainer.length) {
        $coffeeContainer.css({
            display: $tabsHeader.filter('.active').index() === 0 ? 'block' : 'none',
        });

        // Обработка переключения табов
        $tabsHeader.on('shown.bs.tab', (e) => {
            $coffeeContainer.css({
                display: $(e.target).index() === 0 ? 'block' : 'none',
            });
        });
    }

    $('a[href*="#contacts"]').on('click', () => {
        $tabsHeader.eq(2).tab('show').click();

        if ($('.js-menu-panel').is(':visible')) {
            $('.js-menu-panel').addClass('d-none');
            $('body').css('overflow', '');
        }
    });

    $('a[href*="#cooperation"]').on('click', () => {
        $tabsHeader.eq(1).tab('show').click();

        if ($('.js-menu-panel').is(':visible')) {
            $('.js-menu-panel').addClass('d-none');
            $('body').css('overflow', '');
        }
    });
});
